<template>
    <div class="sign-up-modal">
        <template v-if="!isSubmitSuccess && !isSubmitError">
            <div class="custom-modal-header">
                <div>
                    <h2 class="modal-title">Apply for New Account</h2>
                </div>
            </div>

            <div class="signup_box">
                <div class="signup_item">
                    <n-input v-model:value="applyAccountFormData.name" placeholder="Your full name *" size="large"
                        style="width: 100%;" />
                </div>
                <div class="signup_item">
                    <n-input v-model:value="applyAccountFormData.email" placeholder="Your email address *" size="large"
                        style="width: 100%;" @keydown.enter.prevent />
                </div>
                <div class="toggle-switch-container">
                    <p>Do you have an invitation code? <span class="reds">*</span></p>
                    <div class="toggle-switch" :class="{ 'switch-right': registrationMethod === 'apply' }">
                        <div class="toggle-slider"></div>
                        <div class="toggle-option left" :class="{ active: registrationMethod === 'invitation' }"
                            @click="registrationMethod = 'invitation'">
                            Yes
                        </div>
                        <div class="toggle-option right" :class="{ active: registrationMethod === 'apply' }"
                            @click="registrationMethod = 'apply'">
                            No
                        </div>
                    </div>
                </div>
                <template v-if="registrationMethod === 'invitation'" path="invitation_code" label="Your invitation code"
                    required style="width: 100%;">
                    <n-input v-model:value="applyAccountFormData.invitation_code" placeholder="Your invitation code *"
                        size="large" style="width: 100%;" @keydown.enter.prevent />
                </template>


                <template v-if="registrationMethod === 'apply'" path="description"
                    label="What do you plan to use HopeAI for?" required style="width: 100%;">
                    <n-input v-model:value="applyAccountFormData.description" type="textarea"
                        placeholder="Please describe your intended use case for HopeAI..." size="large"
                        style="width: 100%;" :autosize="{
                            minRows: 3,
                            maxRows: 3,
                        }" @keydown.enter.prevent />
                </template>

                <div class="form-button-section" style="color: black;">
                    <div class="cloud-wrap">

                        <template v-if="isReLoad">
                            <vue-turnstile :site-key="cloud_key" v-model="token" theme="auto" />
                        </template>
                    </div>

                    <div class="button-group" style="display: flex; gap: 16px; width: 100%;">

                        <n-button class="request_submit" :disabled="token.length === 0"
                            @click="handleValidateButtonClick" type="primary" size="large" secondary
                            :loading="isSubmitLoading || token.length === 0">
                            {{ isSubmitLoading || token.length === 0 ?
                                'Loading...' :
                                'Submit Application' }}
                        </n-button>

                    </div>
                    <div class="register_entry" v-if="!isMobile">
                        <span>Already have an account?</span>
                        <a href="javascript:;" class="register_link" @click="goToLogin">Login</a>
                    </div>
                </div>
            </div>

        </template>
        <div v-else-if="isSubmitError" class="error-content">

            <!-- Friendly Reminder Icon -->
            <div class="error-icon-wrapper">
                <!-- E4201: User exists - Info icon -->
                <div class="error-icon  " v-if="errorCode === 'E4201'">
                    <div class="user-exists-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32"
                            viewBox="0 0 24 24"><!-- Icon from Solar by 480 Design - https://creativecommons.org/licenses/by/4.0/ -->
                            <path fill="#ffffff" fill-rule="evenodd"
                                d="M12 1.25a4.75 4.75 0 1 0 0 9.5a4.75 4.75 0 0 0 0-9.5M8.75 6a3.25 3.25 0 1 1 6.5 0a3.25 3.25 0 0 1-6.5 0"
                                clip-rule="evenodd" />
                            <path fill="#ffffff"
                                d="M19.856 14.573a.75.75 0 0 1 .015 1.06l-1.833 1.89a.75.75 0 0 1-1.114-.043l-.834-1a.75.75 0 0 1 1.153-.96l.3.36l1.252-1.291a.75.75 0 0 1 1.06-.016" />
                            <path fill="#ffffff" fill-rule="evenodd"
                                d="M14.775 12.513A14.5 14.5 0 0 0 12 12.25c-2.313 0-4.445.526-6.024 1.414C4.42 14.54 3.25 15.866 3.25 17.5v.102c-.001 1.162-.002 2.62 1.277 3.662c.629.512 1.51.877 2.7 1.117c1.192.242 2.747.369 4.773.369c2.868 0 4.81-.254 6.12-.741c1.179-.44 1.877-1.082 2.25-1.892a4.75 4.75 0 1 0-5.596-7.604M14.75 16a3.25 3.25 0 1 1 6.5 0a3.25 3.25 0 0 1-6.5 0m-.994-2.135A4.75 4.75 0 0 0 17.31 20.7c-1.07.337-2.733.55-5.31.55c-1.975 0-3.42-.125-4.477-.339c-1.06-.214-1.68-.509-2.05-.81c-.684-.557-.724-1.293-.724-2.601c0-.851.622-1.775 1.961-2.528c1.316-.74 3.184-1.222 5.29-1.222c.605 0 1.193.04 1.755.115"
                                clip-rule="evenodd" />
                        </svg>
                    </div>
                </div>
                <!-- E4202: Application pending - Clock icon (same as waiting list) -->
                <div class="error-icon  " v-else-if="errorCode === 'E4202'">
                    <svg width="80" height="80" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="10" stroke="#7A47B9" stroke-width="2" fill="#F0EBFA" />
                        <path d="M12 6V12L16 14" stroke="#7A47B9" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </div>
            </div>

            <!-- Friendly Title -->
            <h2 class="error-title" v-if="errorCode === 'E4201'">
                Account Already Exists
            </h2>
            <h2 class="error-title" v-else-if="errorCode === 'E4202'">
                Application Received!
            </h2>

            <!-- Friendly Message -->
            <p class="error-message" v-if="errorCode === 'E4201'">
                <template v-if="isMobile">
                    You already have an account with this email address. Please
                    <a href="javascript:void(0)" @click="backToForm"
                        style="color: #7A47B9; text-decoration: underline; font-weight: 600;">Try Another Email</a> to
                    create a new account.

                </template>
                <template v-else>
                    You already have an account with us. <span>You can <a href="javascript:void(0)" @click="goToLogin"
                            style="color: #7A47B9; text-decoration: underline; font-weight: 600;">login</a>
                        to
                        access your account.</span>

                </template>

            </p>
            <p class="error-message" v-else-if="errorCode === 'E4202'">
                Thanks for your application. We'll review it and get back to you <strong>via
                    email</strong>
                soon.
            </p>
            <!-- Action Buttons -->
            <template v-if="isMobile">
                <div class="error-actions">
                    <n-button @click="closeMobile" class="request_submit" type="primary" size="large" secondary
                        style="margin-top: 60px; width: 100%;">
                        Explore Our Platform
                    </n-button>
                </div>
            </template>
            <template v-else>
                <div class="error-actions" v-if="errorCode === 'E4201'">
                    <n-button @click="backToForm" size="large">
                        Try Another Email
                    </n-button>
                    <n-button v-if="!isMobile" type="primary" size="large" @click="goToLogin" class="login_submit">
                        Go to Login
                    </n-button>
                </div>
                <div class="error-actions got_it" v-else-if="errorCode === 'E4202'">
                    <n-button @click="closeModal" type="primary" size="large" class="login_submit">
                        Got it
                    </n-button>
                </div>
            </template>

        </div>
        <!-- Success Content -->
        <div v-else-if="isSubmitSuccess" class="success-content">
            <!-- Success Icon with glow effect -->
            <div class="success-icon-wrapper">
                <div class="success-icon animate__animated animate__zoomIn" v-if="registrationMethod === 'invitation'">
                    <svg width="80" height="80" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="10" fill="#7A47B9" />
                        <path d="M8 12L11 15L16 9" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" class="check-mark" />
                    </svg>
                </div>
                <div class="waiting-icon animate__animated animate__zoomIn" v-else>
                    <svg width="80" height="80" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="10" stroke="#7A47B9" stroke-width="2" fill="#F0EBFA" />
                        <path d="M12 6V12L16 14" stroke="#7A47B9" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" class="clock-hand" />
                    </svg>
                </div>
            </div>

            <!-- Success Title -->
            <h2 class="success-title" v-if="registrationMethod === 'invitation'">
                Congratulations
            </h2>
            <h2 class="success-title" v-else>
                {{ isMobile ? 'Application Received!' : 'You\'re on the waiting list!' }}
            </h2>

            <!-- Success Message -->
            <p class="success-message" v-if="registrationMethod === 'invitation'">
                Please check <strong>your email</strong> for{{ isMobile ? ' access ' : ' login ' }}
                credentials and
                further instructions.
            </p>
            <p class="success-message" v-else>
                Thanks for your application. We'll review it and get back to you <strong>via
                    email</strong>
                soon.
            </p>
            <template v-if="isMobile">
                <n-button @click="closeMobile" class="request_submit" type="primary" size="large" secondary
                    style="margin-top: 60px; width: 100%;">
                    Explore Our Platform
                </n-button>
            </template>
            <template v-else>
                <n-button @click="closeSuccessModal" text
                    style="margin-top: 32px; font-size: 16px; color: #666; text-decoration: underline;">
                    Close
                </n-button>
            </template>

        </div>

        <!-- Error Content (User Already Exists) -->

    </div>
</template>
<script lang="ts" setup>
import { ref, onMounted, watch, onUnmounted, nextTick } from 'vue';
import { useMessage } from 'naive-ui';
import { submitApplication } from "@/api/index";
import VueTurnstile from 'vue-turnstile';

// 确保组件被正确注册
// console.log('VueTurnstile imported:', VueTurnstile);
const isSubmitSuccess = ref(false);
const token = ref<string>('');
const isReLoad = ref(true);
const applyAccountFormData = ref<any>({
    name: '',
    email: '',
    invitation_code: '',
    description: '',
    org_id: "INDIVIDUAL",
    product_code: 'agent-hub'
})

const isSubmitError = ref(false);
const registrationMethod = ref<'invitation' | 'apply'>('invitation');

const loading = ref(false);
const config = useRuntimeConfig();
const cloud_key = config.public.cloudKey || "";
const message = useMessage();

const emit = defineEmits<{
    (e: 'goToLogin', value: boolean): void,
    //close
    (e: 'close'): void,
    (e: 'mobileClose'): void,
}>();
const goToLogin = () => {
    emit('goToLogin', true);
}

const isSubmitLoading = ref(false);
const errorCode = ref(''); // Default to user exists error

const isMobile = ref(false);
let resizeTimer: ReturnType<typeof setTimeout> | null = null;

const checkIsMobile = () => {
    // 检查屏幕尺寸小于768px都归类为移动端
    const newIsMobile = window.innerWidth <= 768;
    if (newIsMobile !== isMobile.value) {
        isMobile.value = newIsMobile;
    }
};

const debouncedCheckIsMobile = () => {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
        checkIsMobile();
    }, 200);
};




const closeMobile = () => {
    emit('mobileClose');
    // // 
    // event.preventDefault();
    // // console.log('🔄 scrollToNextSection clicked');
    // // console.log('📱 isMobile:', isMobile.value);

    // // 只在移动端执行滚动
    // if (!isMobile.value) {
    //     // console.log('🚫 Not mobile, skipping scroll');
    //     return;
    // }

    // // 获取home_wrap容器
    // const homeWrapElement = document.querySelector('.home_wrap') as HTMLElement;

    // if (!homeWrapElement) {
    //     // console.error('❌ homeWrapElement not found');
    //     return;
    // }

    // // 获取容器的高度和当前滚动位置
    // const containerHeight = homeWrapElement.clientHeight;
    // const currentScrollTop = homeWrapElement.scrollTop;

    // // 计算目标滚动位置（滚动一个屏幕高度）
    // const targetScrollTop = currentScrollTop + containerHeight;



    // // 检查容器是否可以滚动
    // const scrollHeight = homeWrapElement.scrollHeight;


    // if (scrollHeight <= containerHeight) {
    //     console.log('🚫 Container is not scrollable');
    //     return;
    // }

    // // 执行滚动
    // try {
    //     // 方法1: 使用scrollTo
    //     homeWrapElement.scrollTo({
    //         top: targetScrollTop,
    //         behavior: 'smooth'
    //     });


    //     // 方法2: 备用方案 - 直接设置scrollTop
    //     setTimeout(() => {
    //         const afterScrollTop = homeWrapElement.scrollTop;
    //         if (Math.abs(afterScrollTop - targetScrollTop) > 50) {
    //             homeWrapElement.scrollTop = targetScrollTop;
    //         }
    //     }, 500);

    // } catch (error) {
    //     console.error('❌ scroll error:', error);

    //     // 备用方案：直接设置scrollTop
    //     homeWrapElement.scrollTop = targetScrollTop;
    // }

}


const handleValidateButtonClick = async () => {
    if (!applyAccountFormData.value.name.trim()) {
        message.error('Please provide your full name');
        return;
    }
    if (!applyAccountFormData.value.email.trim()) {
        message.error('Please enter a valid email address');
        return;
    }
    // Validate based on registration method
    if (registrationMethod.value === 'invitation') {
        if (!applyAccountFormData.value.invitation_code?.trim()) {
            message.error('Please enter your invitation code');
            return;
        }
    } else if (registrationMethod.value === 'apply') {
        if (!applyAccountFormData.value.description.trim()) {
            message.error('Please explain why you need account access');
            return;
        }
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(applyAccountFormData.value.email)) {
        message.error('Please enter a valid email address');
        return;
    }

    isSubmitLoading.value = true;

    const submitData: any = {
        name: applyAccountFormData.value.name,
        email: applyAccountFormData.value.email,
        org_id: 'INDIVIDUAL',
        product_code: 'agent-hub',
        description: applyAccountFormData.value.description,
        invitation_code: applyAccountFormData.value.invitation_code,
    };

    if (registrationMethod.value === 'invitation') {
        delete submitData.description;
    } else {
        delete submitData.invitation_code;
    }

    try {
        const res = await submitApplication(submitData);
        if (res && res.application) {
            // Set success state
            isSubmitSuccess.value = true;
            isSubmitLoading.value = false;
            // Reset form and token
            applyAccountFormData.value = {
                name: '',
                email: '',
                invitation_code: '',
                description: '',
                org_id: "INDIVIDUAL",
                product_code: 'agent-hub'
            };
            // Reset token and cloudflare
            token.value = '';
            isReLoad.value = false;
            setTimeout(() => {
                isReLoad.value = true;
            }, 5);
        }
    } catch (error: any) {
        isSubmitLoading.value = false;
        isSubmitSuccess.value = false;
        loading.value = false;
        // Reset token and cloudflare on error
        token.value = '';
        isReLoad.value = false;
        setTimeout(() => {
            isReLoad.value = true;
        }, 5);

        if (error && error.error_code === 'E4201') {
            // 用户已存在
            errorCode.value = 'E4201';
            isSubmitError.value = true;
        } else if (error && error.error_code === 'E4202') {
            // 用户已存在，可以直接登录
            errorCode.value = 'E4202';
            isSubmitError.value = true;
        } else {
            message.error(error.error || 'Request failed, please try again later');
        }
    }
};
onMounted(async () => {
    console.log(1111);
    applyAccountFormData.value = {
        name: '',
        email: '',
        invitation_code: '',
        description: ''
    }

    // 检测URL参数中的invitation_code
    if (typeof window !== 'undefined') {
        const urlParams = new URLSearchParams(window.location.search);
        const invitationCode = urlParams.get('invitation_code');
        if (invitationCode) {
            applyAccountFormData.value.invitation_code = invitationCode;
            registrationMethod.value = 'invitation';
        }
    }

    checkIsMobile();
    window.addEventListener('resize', debouncedCheckIsMobile);



    if (!cloud_key || cloud_key === '') {
        console.error('❌ Cloudflare site key is missing!');
        message.error('Configuration error: Please contact support');
        return;
    }

    try {
        await nextTick()
        // 确保DOM完全渲染后再显示Turnstile
        setTimeout(() => {
            isReLoad.value = false;
            token.value = '';
            setTimeout(() => {
                isReLoad.value = true;
                console.log('🔄 SignUp vue-turnstile force reloaded on mount');
            }, 5);
        }, 100)
    } catch (error) {
        console.error('Mount error:', error)
    }


})

onUnmounted(() => {
    window.removeEventListener('resize', debouncedCheckIsMobile);
    if (resizeTimer) clearTimeout(resizeTimer);
});


const closeSuccessModal = () => {
    // openModal.value = false;
    emit('close');
}

const backToForm = () => {
    isSubmitError.value = false;
    errorCode.value = '';
}

const closeModal = () => {
    isSubmitError.value = false;
    errorCode.value = '';

}

// Watch cloud_key and token changes
watch(() => cloud_key, (val) => {
    console.log('Cloud key changed:', val);
}, { immediate: true });

// Watch token changes and store in localStorage (same as headItem.vue)
watch(() => token.value, (val) => {
    console.log('Token changed:', val);
    if (val && val.length > 0) {
        localStorage.setItem('CToken', val)
    }
}, { immediate: true })

</script>
<style lang="scss">
.reds {
    color: #bb1111;
}

.sign-up-modal {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    background: #fff;
    padding: 32px 24px 24px 24px;
    display: flex;
    gap: 20px;
    flex-direction: column;
    align-items: center;
}

.signup_box {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .signup_item {
        width: 100%;

        .n-input {
            width: 100%;
        }
    }
}

.button-group {
    width: 100%;
    display: flex;
    gap: 16px;
    justify-content: space-between;
    align-items: center;

    .login {
        flex: 1;
    }


}

.request_submit {
    flex: 1;
    color: #FFF !important;
    font-size: 16px;
    font-weight: 600 !important;
    height: 40px;
    line-height: 40px;
    letter-spacing: 0.5px;
    border-radius: 999px;
    background: linear-gradient(98deg, rgba(190, 53, 176, 0.90) -6.37%, rgba(122, 71, 185, 0.90) 87.51%);
    box-shadow: 1px 3px 4px 0 rgba(0, 0, 0, 0.25);

    .n-button__content {
        font-weight: 600 !important;
    }
}

.toggle-switch-container {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
    color: #333;
}

.toggle-switch {
    position: relative;
    display: flex;
    align-items: center;
    background: #f0f0f0;
    border-radius: 25px;
    height: 44px;
    width: 100%;
    transition: all 0.3s ease;
}

.toggle-slider {
    position: absolute;
    width: 50%;
    height: 40px;
    background: #7A47B9;
    border-radius: 25px;
    transition: transform 0.3s ease;
    top: 2px;
    left: 2px;
}

.toggle-switch.switch-right .toggle-slider {
    transform: translateX(calc(100% - 4px));
}

.toggle-option {
    flex: 1;
    text-align: center;
    color: #666;
    height: 100%;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    z-index: 1;
    transition: color 0.3s ease;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: center;
}

.toggle-option.active {
    color: white;
    font-weight: 600;
}

.custom-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 24px;

    .modal-title {
        font-size: 32px;
        font-weight: 700;
        margin-bottom: 24px;
        color: #1a1a1a;
        width: 100%;
        margin: 0;
    }

    .close-icon {
        cursor: pointer;
        color: #666;
        transition: color 0.3s;

        &:hover {
            color: #333;
        }
    }
}

.success-content {
    text-align: center;
    padding: 40px 20px;

    .success-icon-wrapper {
        margin-bottom: 32px;
        position: relative;

        .success-icon,
        .waiting-icon {
            display: inline-block;
            position: relative;
            animation: bounceIn 0.6s ease-out;

            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 120px;
                height: 120px;
                background: radial-gradient(circle, rgba(122, 71, 185, 0.15) 0%, transparent 70%);
                border-radius: 50%;
                animation: pulse 2s infinite;
            }

            svg {
                position: relative;
                z-index: 1;
            }

            .check-mark {
                stroke-dasharray: 20;
                stroke-dashoffset: 20;
                animation: checkmark 0.6s ease-out 0.3s forwards;
            }

            .clock-hand {
                transform-origin: center;
                // No rotation animation
            }
        }
    }

    .success-title {
        font-size: 28px;
        font-weight: 600;
        color: #1a1a1a;
        margin: 0 0 16px 0;
    }

    .success-message {
        font-size: 16px;
        line-height: 1.6;
        color: #666;
        max-width: 380px;
        margin: 0 auto 32px auto;

        strong {
            color: #333;
            font-weight: 600;
        }
    }
}

.error-content {
    position: relative;
    text-align: center;
    padding: 40px 0;



    .error-icon-wrapper {
        margin-bottom: 32px;
        position: relative;

        .error-icon {
            display: inline-block;
            position: relative;
            animation: bounceIn 0.6s ease-out;

            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 120px;
                height: 120px;
                background: radial-gradient(circle, rgba(255, 167, 38, 0.15) 0%, transparent 70%);
                border-radius: 50%;
                animation: pulse 2s infinite;
            }

            svg {
                position: relative;
                z-index: 1;
            }
        }

        .user-exists-icon {
            background: #7A47B9;
            width: 64px;
            height: 64px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;

        }
    }

    .error-title {
        font-size: 28px;
        font-weight: 600;
        color: #1a1a1a;
        margin: 0 0 16px 0;
    }

    .error-message {
        font-size: 16px;
        line-height: 1.5;
        color: #666;
        max-width: 380px;
        margin: 0 auto 32px;
    }

    .error-actions {
        display: flex;
        justify-content: space-between;
        gap: 16px;
        width: 100%;

        button {
            width: 46%;
        }

        &.got_it {
            justify-content: center;

            button {
                width: 40%;
            }
        }
    }
}

@media (max-width: 576px) {
    .custom-modal-header .modal-title {
        font-size: 28px;
    }

    .sign-up-modal {
        padding: 0px 24px;
    }

    .cloud-wrap {
        min-height: 74px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        overflow: visible !important;
    }

    .cloud-wrap iframe {
        transform: scale(0.9);
        transform-origin: center;
    }

    .n-input .n-input__input-el {
        height: 44px !important;
        line-height: 44px !important;
    }

    .button-group .request_submit {
        height: 44px !important;
        line-height: 44px !important;
    }
}
</style>